import { HFlow, useStyles } from 'bold-ui'
import { PageContent } from 'components/layout/PageContent'
import { useBuscaDetailCidadaoQuery } from 'graphql/hooks.generated'
import React, { CSSProperties, Dispatch } from 'react'
import { Acoes } from 'view/cidadao/visualizacao/CidadaoCabecalhoSection'
import { CidadaoInformacoesView } from 'view/cidadao/visualizacao/CidadaoInformacoesView'

import { AtendimentoFooter } from '../AtendimentoFooter'

interface CidadaoDetailViewProps {
  atendimentoId: ID
  cidadaoId: ID
  isAtendimentoOdonto?: boolean
  clearCache: Dispatch<void>
}

export function CidadaoDetailView(props: CidadaoDetailViewProps) {
  const { atendimentoId, cidadaoId, isAtendimentoOdonto, clearCache } = props
  const { data } = useBuscaDetailCidadaoQuery({ variables: { id: cidadaoId } })
  const { classes } = useStyles(createStyles)

  return (
    <>
      <PageContent fluid type='filled'>
        {data?.cidadao && (
          <>
            <div className={classes.actions}>
              <HFlow hSpacing={0.5} justifyContent='flex-end'>
                <Acoes
                  cidadao={data.cidadao}
                  sizeBotaoAtualizar='small'
                  botaoVerAgendamentos={true}
                  callbackUrl='cadastro-cidadao'
                  callbackParams={atendimentoId}
                />
              </HFlow>
            </div>
            <div className={classes.detail}>
              <CidadaoInformacoesView cidadao={data.cidadao} />
            </div>
          </>
        )}
      </PageContent>
      <AtendimentoFooter
        atendimentoId={atendimentoId}
        isAtendimentoOdonto={isAtendimentoOdonto}
        clearCache={clearCache}
      />
    </>
  )
}

export const createStyles = () => ({
  actions: {
    position: 'relative',
    zIndex: 8,
  } as CSSProperties,
  detail: {
    position: 'relative',
    top: '-4rem',
  } as CSSProperties,
})
